import styled, { keyframes } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
const fadeInFadeOut = keyframes `
  0% {
    opacity: 1
  }

  50% {
    opacity: 0.4
  }

  100% {
    opacity: 1
  }
`;
const StyledCommonSkeletonShape = styled.div.withConfig({ displayName: "auir-41e20d9-StyledCommonSkeletonShape", componentId: "auir-41e20d9-1dy8g5u" }) `
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  aspect-ratio: ${(props) => props.aspectRatio};
  background-color: var(${(props) => props.theme.colors.ui.highlight.tertiary});
  -webkit-animation: ${fadeInFadeOut} 2s ease-in-out 0.5s infinite;
  animation: ${fadeInFadeOut} 2s ease-in-out 0.5s infinite;
  cursor: progress;
  ${injectSpacing('margin')}
`;
export const StyledRectangularSkeletonShape = styled(StyledCommonSkeletonShape).withConfig({ displayName: "auir-41e20d9-StyledRectangularSkeletonShape", componentId: "auir-41e20d9-ff6zlh" }) `
  border-radius: 0%;
`;
export const StyledCircularSkeletonShape = styled(StyledCommonSkeletonShape).withConfig({ displayName: "auir-41e20d9-StyledCircularSkeletonShape", componentId: "auir-41e20d9-1qk3i8o" }) `
  border-radius: 100%;
`;
export const StyledOvalSkeletonShape = styled(StyledCommonSkeletonShape).withConfig({ displayName: "auir-41e20d9-StyledOvalSkeletonShape", componentId: "auir-41e20d9-1pkmzvr" }) `
  border-radius: 40px;
`;
//# sourceMappingURL=SkeletonShape.styles.mjs.mjs.map